(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["PruebaSelector2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.getElementById('mobli-benefit-selector');
    if (!root) return;

    var tabButtons = root.querySelectorAll('[data-tab]');
    var panels = root.querySelectorAll('[data-tab-panel]');
    var headings = root.querySelectorAll('.mobli-section__heading');

    function setActiveTab(target) {
      if (!target) return;
      var tab = target.getAttribute('data-tab');
      if (!tab) return;

      tabButtons.forEach(function (button) {
        var isActive = button.getAttribute('data-tab') === tab;
        button.classList.toggle('mobli-section__tab--active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        button.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach(function (panel) {
        var matches = panel.getAttribute('data-tab-panel') === tab;
        panel.classList.toggle('mobli-section__panel--active', matches);
        panel.hidden = !matches;
      });

      headings.forEach(function (heading) {
        var matches = heading.getAttribute('data-tab-panel') === tab;
        heading.hidden = !matches;
        heading.setAttribute('aria-hidden', matches ? 'false' : 'true');
      });
    }

    function handleTabClick(event) {
      var button = event.currentTarget;
      if (!document.startViewTransition) {
        setActiveTab(button);
        return;
      }

      document.startViewTransition(function () {
        setActiveTab(button);
      });
    }

    tabButtons.forEach(function (button) {
      button.addEventListener('click', handleTabClick);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eventos-cotizador"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var COP = new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 });
  var items = Array.prototype.slice.call(document.querySelectorAll('.ev-cot-item'));
  var stickyBar = document.getElementById('evStickyBar');
  var totalEl = document.getElementById('evTotal');
  var selCountEl = document.getElementById('evSelCount');
  var stickyTotal = document.getElementById('evStickyTotal');
  var stickyCount = document.getElementById('evStickyCount');
  var waLink = document.getElementById('evWaLink');
  var waBase = waLink ? waLink.getAttribute('href') : '';
  var bodyField = document.getElementById('evBody');
  var purchaseToggle = document.getElementById('evPurchaseToggle');
  var currentPurchaseType = 'daily_rent';

  function applyPurchaseType(type) {
    currentPurchaseType = type;
    items.forEach(function (el) {
      var priceKey = type === 'daily_rent' ? 'priceDaily' : 'pricePurchase';
      var moneyKey = type === 'daily_rent' ? 'moneyDaily' : 'moneyPurchase';
      el.dataset.price = el.dataset[priceKey];
      var amountEl = el.querySelector('.ev-cot-item__price-amount');
      var suffixEl = el.querySelector('.ev-cot-item__price-suffix');
      if (amountEl) amountEl.textContent = el.dataset[moneyKey];
      if (suffixEl) suffixEl.textContent = type === 'daily_rent' ? '/día' : '';
    });
    render();
  }

  if (purchaseToggle) {
    purchaseToggle.addEventListener('click', function (e) {
      var btn = e.target.closest('.ev-cot__purchase-btn');
      if (!btn) return;
      purchaseToggle.querySelectorAll('.ev-cot__purchase-btn').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
        b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
      });
      applyPurchaseType(btn.dataset.purchaseType);
    });
  }

  function getState() {
    var lines = [];
    var totalPieces = 0;
    var totalPrice = 0;
    items.forEach(function (el) {
      var qty = parseInt(el.querySelector('.ev-cot-item__qty').textContent, 10) || 0;
      if (qty > 0) {
        var price = parseFloat(el.dataset.price);
        var name = el.dataset.name;
        var suffix = currentPurchaseType === 'daily_rent' ? '/día' : '';
        totalPieces += qty;
        totalPrice += price * qty;
        lines.push('• ' + qty + '× ' + name + ' — ' + COP.format(price * qty) + suffix);
      }
    });
    return { lines: lines, totalPieces: totalPieces, totalPrice: totalPrice };
  }

  function render() {
    var s = getState();
    if (totalEl) totalEl.textContent = COP.format(s.totalPrice);
    if (selCountEl) selCountEl.textContent = s.totalPieces === 0 ? 'Sin piezas aún' : s.totalPieces + (s.totalPieces === 1 ? ' pieza' : ' piezas');
    if (stickyBar) {
      stickyBar.hidden = s.totalPieces === 0;
      if (stickyCount) stickyCount.textContent = s.totalPieces + (s.totalPieces === 1 ? ' pieza' : ' piezas');
      var stickySuffix = currentPurchaseType === 'daily_rent' ? '/día*' : '*';
      if (stickyTotal) stickyTotal.textContent = COP.format(s.totalPrice) + stickySuffix;
    }
    updateLinks(s);
  }

  function updateLinks(s) {
    var nombre = valueOf('input[name="contact[Nombre]"]');
    var celular = valueOf('input[name="contact[Celular]"]');
    var tipo = valueOf('#evTipo');
    var fecha = valueOf('#evFecha');
    var ciudad = valueOf('#evCiudad');
    var invitados = valueOf('#evInvitados');

    var datos = [
      nombre ? 'Nombre: ' + nombre : null,
      celular ? 'Celular: ' + celular : null,
      tipo ? 'Tipo: ' + tipo : null,
      fecha ? 'Fecha: ' + fecha : null,
      ciudad ? 'Ciudad: ' + ciudad : null,
      invitados ? 'Invitados: ' + invitados : null
    ].filter(Boolean).join('\n');

    var msg = 'Hola möblirent 👋 Quiero cotizar el menaje para mi evento.\n\n' + datos;
    if (s.lines.length) {
      var totalSuffix = currentPurchaseType === 'daily_rent' ? '/día' : '';
      msg += '\n\nPiezas seleccionadas:\n' + s.lines.join('\n') + '\n\nEstimado: ' + COP.format(s.totalPrice) + totalSuffix;
    }
    if (waLink) waLink.setAttribute('href', waBase + '?text=' + encodeURIComponent(msg));
    if (bodyField) bodyField.value = msg;
  }

  function valueOf(sel) {
    var el = document.querySelector(sel);
    return el ? el.value : '';
  }

  items.forEach(function (el) {
    var qtyEl = el.querySelector('.ev-cot-item__qty');
    var incBtn = el.querySelector('.ev-cot-item__inc');
    var decBtn = el.querySelector('.ev-cot-item__dec');
    function setQty(n) {
      n = Math.max(0, n);
      qtyEl.textContent = n;
      el.classList.toggle('ev-cot-item--active', n > 0);
      render();
    }
    incBtn.addEventListener('click', function () { setQty((parseInt(qtyEl.textContent, 10) || 0) + 1); });
    decBtn.addEventListener('click', function () { setQty((parseInt(qtyEl.textContent, 10) || 0) - 1); });
  });

  // Sugerencia por # de invitados → primer producto del grupo marcado como "silla" (data-is-chair-group="True")
  var invitadosInput = document.getElementById('evInvitados');
  var suggestBtn = document.getElementById('evSuggestChair');
  var suggestText = document.getElementById('evSuggestText');
  var chairGroup = document.querySelector('.ev-cot__group[data-is-chair-group="True"]') || document.querySelector('.ev-cot__group[data-is-chair-group="true"]');
  var firstChair = chairGroup ? chairGroup.querySelector('.ev-cot-item') : null;

  function refreshSuggestion() {
    if (!invitadosInput || !suggestBtn || !firstChair) return;
    var n = parseInt(invitadosInput.value, 10);
    var currentQty = parseInt(firstChair.querySelector('.ev-cot-item__qty').textContent, 10) || 0;
    if (n > 0 && currentQty < n) {
      suggestText.textContent = 'Añadir ' + n + ' ' + firstChair.dataset.name + ' para tus invitados';
      suggestBtn.hidden = false;
    } else {
      suggestBtn.hidden = true;
    }
  }

  if (invitadosInput) invitadosInput.addEventListener('input', function () { refreshSuggestion(); render(); });
  ['input[name="contact[Nombre]"]', 'input[name="contact[Celular]"]', '#evTipo', '#evFecha', '#evCiudad'].forEach(function (sel) {
    var el = document.querySelector(sel);
    if (el) el.addEventListener('input', render);
    if (el) el.addEventListener('change', render);
  });

  if (suggestBtn && firstChair) {
    suggestBtn.addEventListener('click', function () {
      var n = parseInt(invitadosInput.value, 10) || 0;
      firstChair.querySelector('.ev-cot-item__qty').textContent = n;
      firstChair.classList.toggle('ev-cot-item--active', n > 0);
      render();
      refreshSuggestion();
    });
  }

  render();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
